import {LinearProgress, Button, Typography, Stack, Paper, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {SnackbarContent} from 'notistack';

export const Component = (closeSnackbar: () => void, text?: string) => {
  return (
    <Button
      color="inherit"
      onClick={() => {
        closeSnackbar();
      }}
    >
      {text ?? 'Dismiss'}
    </Button>
  );
};

export const Progress = (closeSnackbar: () => void, message?: string) => {
  return (
    <SnackbarContent>
      <Paper elevation={2}>
        <Stack direction={'row'} py={1} pl={2} pr={1} spacing={1} alignItems={'center'}>
          <Typography>{message}</Typography>
          <IconButton
            color="inherit"
            size="small"
            disableRipple
            onClick={() => {
              closeSnackbar();
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Stack>
        <LinearProgress sx={{width: '100%', height: '2px'}} />
      </Paper>
    </SnackbarContent>
  );
};
